import React from "react"
import { FaGamepad } from "react-icons/fa"
import Header from "../components/header"

export default function toolkitPage() {
    return (
        <div>
            <Header />
            <div className="columns is-centered is-mobile">
                <div className="column is-8">
                    <h1 class="title my-5">Toolkit</h1>
                    <p>
                        Here's a list of resources that you might find useful. I use mostly free, sometimes open-source software, so the list below will reflect that.
                    </p>
                    <div className="columns my-4">

                        <table className='table is-hoverable'>
                            <thead>
                                <tr>
                                    <th>Tool</th>
                                    <th>Description</th>
                                    <th>Use</th>
                                    <th>Cost</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th><a href="https://unity.com">Unity</a></th>
                                    <td>An extremely powerful, fully featured and mostly free game engine I use to make games. It's very accessible and great for small budget indie games and AAA titles alike. If you're here, you likely don't need my endorsement.</td>
                                    <td><span className="tag is-warning">Game Engine</span></td>
                                    <td>Free</td>
                                </tr>
                                <tr>
                                    <th><a href="https://blender.org">Blender</a></th>
                                    <td>It's insane that this is open source. Comes with industry-standard 3D modelling, animation, texturing, shading, simulation, rendering and compositing setup, as well as one of the best free video editors around. I use the VSE to make all my videos.</td>
                                    <td><span className="tag is-warning">3D Art</span><span className="tag is-warning">Video Editing</span></td>
                                    <td>Open Source</td>
                                </tr>
                                <tr>
                                    <th><a href="https://aseprite.org">Aseprite</a></th>
                                    <td>The absolute best and among the most popular pixel art and pixel animation software. Packed with incredible features and moddable with Lua. I don't know of anything that can compete with it. Extremely cheap, though the source is available on GitHub if you can compile it.</td>
                                    <td><span className="tag is-warning">Pixel Art</span></td>
                                    <td>$20</td>
                                </tr>
                                <tr>
                                    <th><a href="https://krita.org">Krita</a></th>
                                    <td>Excellent and fully featured 2D illustration and animation software. I use it heavily for storyboarding, concept art and making frame-based animation with my tablet.</td>
                                    <td><span className="tag is-warning">2D Art</span></td>
                                    <td>Free</td>
                                </tr>
                                <tr>
                                    <th><a href="https://krita.org">Audacity</a></th>
                                    <td>Audio editing software packed with features and has more effects than I know what to do with. You could probably use it as a DAW, but it's not really meant for that. Instead, it works great for recording and polishing audio, VO, and acoustic guitar playing.</td>
                                    <td><span className="tag is-warning">Audio Editing</span></td>
                                    <td>Free</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    );
}